// FloatingChatButton.js
import React from 'react';
import { Box, IconButton } from '@mui/material';
import { FloatingChatImage } from '../styles/LandingPage';
import connitLogo from '../assets/images/logo/logo.png';

const FloatingChatButton = ({ onGetStarted }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: '5%',
        right: '5%',
      }}
    >
      <IconButton
        size="large"
        onClick={onGetStarted}
        sx={{
          borderRadius: '50%',
          boxShadow: '4px 4px 12px rgba(0, 0, 0, 0.3)',
          backgroundColor: '#fff',
          transition: 'background-color 0.3s ease',
          '&:hover': {
            backgroundColor: '#FF5733',
          },
        }}
      >
        <FloatingChatImage src={connitLogo} alt="Chat Logo" />
      </IconButton>
    </Box>
  );
};

export default FloatingChatButton;
